import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasEntitlement, hasAnyEntitlement } from '../../utils/entitlements';

/**
 * @param {string} [service] - heatmaps | ab_testing | cwv | clickpath | campaigns | seomax | swiss
 * @param {string[]} [anyOf] - allow if any of these keys is true
 */
export default function RequireEntitlement({ service, anyOf, children }) {
  const { user } = useAuth();
  const location = useLocation();

  let ok = true;
  if (anyOf?.length) {
    ok = hasAnyEntitlement(user, anyOf);
  } else if (service) {
    ok = hasEntitlement(user, service);
  }

  if (!ok) {
    return (
      <Navigate
        to="/subscriptions"
        replace
        state={{ from: location.pathname, needLicense: service || anyOf?.[0] }}
      />
    );
  }
  return children;
}
